module.exports = __webpack_public_path__ + "static/img_6673_optimized-3a5f5314d1eb09fe6680a731d58633f7.jpg";